import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import sweetalert from "sweetalert";
import ApiEnter from "@/api/ApiEnter";
import ApiPageSpecificFaq from "@/api/ApiPageSpecificFaq";
import StandartTemplate from "@/components/Template/StandartTemplate.vue";
import LeftMenuTab from "@/components/LeftMenu/LeftMenuTab.vue";
import PageHeader from "@/components/UI/PageHeader.vue";
import dayjs from "dayjs";
import { Getter } from "vuex-class";
import EUserEnum from "@/struct/user/EUserEnum";
import i18n from "@/i18n";
let PageSpecificFaqUrls = class PageSpecificFaqUrls extends Vue {
    constructor() {
        super(...arguments);
        this.Breadcrumbs = [
            {
                to: "/",
                text: "Home"
            },
            {
                to: "/page-specific-faq",
                exact: true,
                text: "Page specific FAQ"
            },
            {
                text: "URL's",
                disabled: true
            }
        ];
        this.TableHeaders = [
            {
                text: i18n.t("table_headers.sorting"),
                value: "priority",
                width: "10%"
            },
            {
                text: "URL",
                value: "url",
                width: "40%"
            },
            {
                text: "Name",
                value: "name",
                width: "30%"
            },
            {
                text: i18n.t("table_headers.action"),
                value: "action"
            }
        ];
        this.TableItems = [];
        this.isOpenDialog = false;
        this.isOpenEditDialog = false;
        this.newCategory = {
            name: "",
            url: "",
            priority: "",
            publish: true,
            created: ""
        };
        this.currentCategory = {
            name: "",
            url: "",
            priority: "",
            publish: true,
            created: "",
            uuid: ""
        };
    }
    CanAdminAccess() {
        return this.GetCurrentSessionUser != undefined && this.GetCurrentSessionUser.system_role == EUserEnum.SystemRole.SuperAdmin;
    }
    OpenDialog() {
        this.isOpenDialog = !this.isOpenDialog;
        this.newCategory.name = "";
        this.newCategory.url = "";
        this.newCategory.priority = "";
        this.newCategory.publish = true;
        this.newCategory.created = "";
    }
    OpenEditDialog() {
        this.isOpenEditDialog = !this.isOpenEditDialog;
    }
    async CreateFaqUrl() {
        if (ApiEnter.CurrentSessionUUID != undefined) {
            this.$forceUpdate();
            const faq_uuid = await ApiPageSpecificFaq.CreateFaqUrl(ApiEnter.CurrentSessionUUID, this.newCategory.name, this.newCategory.url, this.newCategory.priority, this.newCategory.publish ? 1 : 0);
            if (faq_uuid == undefined || faq_uuid.length != 36) {
                await sweetalert({
                    title: "Ошибка запроса!",
                    text: "Ошибка создания FAQ: " + faq_uuid,
                    icon: "info"
                });
                return;
            }
            this.$forceUpdate();
            sweetalert({
                title: "Success!",
                text: `FAQ url has created!`,
                icon: "success"
            }).then(() => this.OpenDialog());
            await this.GetFaqUrls();
        }
    }
    async ChangeFaqUrlPublish(item) {
        try {
            const response = await ApiPageSpecificFaq.UpdateFaqUrlPublish(item.publish ? 1 : 0, ApiEnter.CurrentSessionUUID, item.uuid);
            if (typeof response == "boolean") {
                sweetalert({
                    title: this.$t("general.success"),
                    text: this.$t("general.success_updated"),
                    icon: "success"
                }).then(() => {
                    this.GetFaqUrls();
                });
            }
            else {
                sweetalert({
                    title: this.$t("general.error"),
                    text: this.$t("general.request_error"),
                    icon: "info"
                });
            }
        }
        catch (e) {
            console.error(e);
            sweetalert({
                title: this.$t("general.error"),
                text: this.$t("general.request_error"),
                icon: "info"
            });
        }
    }
    async ChangeFaqCategoryInfo() {
        try {
            const response = await ApiPageSpecificFaq.UpdateFaqUrlInfo(this.currentCategory.name, this.currentCategory.url, this.currentCategory.priority, this.currentCategory.publish ? 1 : 0, ApiEnter.CurrentSessionUUID, this.currentCategory.uuid);
            if (typeof response == "boolean") {
                sweetalert({
                    title: this.$t("general.success"),
                    text: this.$t("general.success_updated"),
                    icon: "success"
                }).then(() => {
                    this.OpenEditDialog();
                    this.GetFaqUrls();
                });
            }
            else {
                sweetalert({
                    title: this.$t("general.error"),
                    text: this.$t("general.request_error"),
                    icon: "info"
                });
            }
        }
        catch (e) {
            console.error(e);
            sweetalert({
                title: this.$t("general.error"),
                text: this.$t("general.request_error"),
                icon: "info"
            });
        }
    }
    async openEditDialog(uuid) {
        this.currentCategory.uuid = uuid;
        const categoryInfo = await ApiPageSpecificFaq.GetFaqUrlByUUID(ApiEnter.CurrentSessionUUID, uuid);
        if (categoryInfo == undefined) {
            await sweetalert({
                title: this.$t("general.error"),
                text: this.$t("general.request_error"),
                icon: "info"
            });
            return;
        }
        this.OpenEditDialog();
        this.currentCategory.name = categoryInfo.name;
        this.currentCategory.url = categoryInfo.url;
        this.currentCategory.priority = categoryInfo.priority;
        this.currentCategory.publish = categoryInfo.publish;
        this.currentCategory.created = dayjs.tz(categoryInfo.create_at, "Europe/Rome").format("DD.MM.YYYY");
    }
    DeleteUrl(faq_uuid) {
        sweetalert({
            title: this.$t("general.confirm"),
            text: this.$t("files.accept_delete"),
            icon: "warning",
            buttons: [this.$t("general.no"), this.$t("general.yes")]
        }).then(async (isConfirm) => {
            if (isConfirm == true) {
                const response = await ApiPageSpecificFaq.DeleteFaqUrl(ApiEnter.CurrentSessionUUID, faq_uuid);
                if (typeof response == "boolean") {
                    await sweetalert({
                        title: this.$t("general.success"),
                        text: this.$t("general.success_deleted"),
                        icon: "success"
                    });
                    await this.GetFaqUrls();
                }
                else {
                    await sweetalert({
                        title: this.$t("general.error"),
                        text: this.$t("general.request_error"),
                        icon: "info"
                    });
                }
            }
        });
    }
    async GetFaqUrls() {
        try {
            this.TableItems = await ApiPageSpecificFaq.GetFaqUrls(ApiEnter.CurrentSessionUUID);
        }
        catch (e) {
            console.error(e);
        }
    }
    created() {
        this.GetFaqUrls();
    }
};
__decorate([
    Getter("getCurrentSessionUser")
], PageSpecificFaqUrls.prototype, "GetCurrentSessionUser", void 0);
PageSpecificFaqUrls = __decorate([
    Component({
        components: { PageHeader, StandartTemplate, LeftMenuTab }
    })
], PageSpecificFaqUrls);
export default PageSpecificFaqUrls;
